<template>
  <Dialog :show.sync="visible" width="500px" title="峰值谱线表">
    <template v-slot:body>
      <div class="dialog-body">
        <el-table :data="list">
          <el-table-column prop="hz" label="频率（Hz）"/>
          <el-table-column prop="value" label="峰值"/>
        </el-table>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button size="small" type="primary" @click="visible = false">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      list:[]
    }
  },
  methods: {
    open(list=[]) {
      this.visible = true
      this.list = list.map(item=>{
        return {
          hz: item[0],
          value: item[1],
        }
      })
    },
  }
}
</script>
